import PropTypes from "prop-types";

const propTypes = {
  setSortType: PropTypes.func.isRequired,
  setSortAscending: PropTypes.func.isRequired
};

export default propTypes;
